<template>
  <div class="data-publish-container">
    <div class="common-tabs-box">
      <el-tabs
        v-model="activeTab"
        class="tab-page-primary">
        <el-tab-pane
          label="数据导出"
          name="export"
          v-if="isChecked('Data.Migration.Export.List')">
          <DataExport
            v-if="activeTab === 'export'"
            :openExportDialog="openExportDialog"
            :openProjPublishDialog="openProjPublishDialog"
            :openPublishRecordDialog="openPublishRecordDialog"
            :openPlatFormManageDialog="openPlatFormManageDialog"
            :updatePublishInfo="updatePublishInfo"
            :openPublishDialog="openPublishDialog" />
        </el-tab-pane>
        <el-tab-pane
          label="数据导入"
          name="import"
          v-if="isChecked('Data.Migration.Import.List')">
          <DataImport
            v-if="activeTab === 'import'"
            :openUploadListDialog="openUploadListDialog"
            :updateImportType="updateImportType"
            :importUploader="importUploader"
            :openImportDialog="openImportDialog" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <DataExportDialog
      :visible="exportDialogVisible"
      :closeDialog="closeExportDialog" />
    <PublishDialog
      :visible="publishDialogVisible"
      :publishInfo="publishInfo"
      :closeDialog="closePublishDialog" />
    <ProjPublishDialog
      :visible="projPublishDialogVisible"
      :closeDialog="closeProjPublishDialog" />
    <PublishRecordDialog
      :visible="publishRecordDialogVisible"
      :closeDialog="closePublishRecordDialog" />
    <PlatFormManageDialog
      :visible="platformManageDialogVisible"
      :openAddPlatFormDialog="openAddPlatFormDialog"
      :closeDialog="closePlatformManageDialog" />
    <AddPlatFormDialog
      :visible="addPlatformDialogVisible"
      :closeDialog="closeAddPlatformDialog" />
    <UploadList
      :visible="uploadListDialogVisible"
      :closeDialog="closeUploadListDialog" />
    <MiniUploadList :importUploader="importUploader" />
    <ImportDialog
      :visible="importDialogVisible"
      :importType="importType"
      :importFilesInfo="importFilesInfo"
      :closeDialog="closeImportDialog" />
  </div>
</template>

<script>
import DataExport from './dataExport/DataExport.vue'
import DataExportDialog from './dataExport/DataExportDialog.vue'
import PublishDialog from './dataExport/PublishDialog.vue'
import ProjPublishDialog from './dataExport/ProjPublishDialog.vue'
import PublishRecordDialog from './dataExport/PublishRecordDialog.vue'
import PlatFormManageDialog from './dataExport/PlatFormManageDialog.vue'
import AddPlatFormDialog from './dataExport/AddPlatFormDialog.vue'
import DataImport from './dataImport/DataImport.vue'
import UploadList from './dataImport/UploadList.vue'
import MiniUploadList from './dataImport/MiniUploadList.vue'
import ImportDialog from './dataImport/ImportDialog.vue'

import ImportUploader from '@/utils/importUploader'
import { Store } from '@/utils/store'

import {
  importUploadListService,
  pauseImportService
} from '@/service/interface'

export default {
  data() {
    return {
      activeTab: 'export',
      exportDialogVisible: false,
      publishInfo: {},
      publishDialogVisible: false,
      projPublishDialogVisible: false,
      publishRecordDialogVisible: false,
      platformManageDialogVisible: false,
      addPlatformDialogVisible: false,
      uploadListDialogVisible: false,
      importType: 0,
      importDialogVisible: false,
      importFilesInfo: [],
      importUploader: null
    }
  },
  components: {
    DataExport,
    DataExportDialog,
    PublishDialog,
    ProjPublishDialog,
    PublishRecordDialog,
    PlatFormManageDialog,
    AddPlatFormDialog,
    DataImport,
    UploadList,
    MiniUploadList,
    ImportDialog
  },
  created() {
    if (this.isChecked('Data.Migration.Export.List')) {
      this.activeTab = 'export'
    } else {
      this.activeTab = 'import'
    }

    if (this.isChecked('Data.Migration.Import.List')) {
      let uploaders = Store.uploaders
      let find = uploaders.find(el => el.schemeType === 'ImportDoc')
      if (find) {
        this.importUploader = find.uploader
      } else {
        this.importUploader = new ImportUploader('ImportDoc')
      }

      let pauseFlag = JSON.parse(sessionStorage.getItem('importPauseFlag'))
      if (!pauseFlag) {
        this.pauseFilesUpload()
      }
    }
  },
  mounted() {
    window.addEventListener('unload', this.onUnLoad)
  },
  methods: {
    openExportDialog() {
      this.exportDialogVisible = true
    },
    closeExportDialog() {
      this.exportDialogVisible = false
    },
    openPublishDialog() {
      this.publishDialogVisible = true
    },
    updatePublishInfo(publishInfo) {
      this.publishInfo = publishInfo
    },
    closePublishDialog() {
      this.publishDialogVisible = false
      this.publishInfo = {}
    },
    openProjPublishDialog() {
      this.projPublishDialogVisible = true
    },
    closeProjPublishDialog() {
      this.projPublishDialogVisible = false
    },
    openPublishRecordDialog() {
      this.publishRecordDialogVisible = true
    },
    closePublishRecordDialog() {
      this.publishRecordDialogVisible = false
    },
    openPlatFormManageDialog() {
      this.platformManageDialogVisible = true
    },
    closePlatformManageDialog() {
      this.platformManageDialogVisible = false
    },
    openAddPlatFormDialog() {
      this.addPlatformDialogVisible = true
    },
    closeAddPlatformDialog() {
      this.addPlatformDialogVisible = false
    },
    openUploadListDialog() {
      this.uploadListDialogVisible = true
    },
    closeUploadListDialog() {
      this.uploadListDialogVisible = false
    },
    openImportDialog(importFilesInfo) {
      this.importFilesInfo = importFilesInfo ? importFilesInfo : []
      this.importDialogVisible = true
    },
    updateImportType(importType) {
      this.importType = importType
    },
    closeImportDialog() {
      this.importFilesInfo = []
      this.importDialogVisible = false
    },
    onUnLoad() {
      sessionStorage.setItem('importPauseFlag', false)
    },
    pauseFilesUpload() {
      this.queryFilesUpload().then(uploadingFiles => {
        if (uploadingFiles.length) {
          let fileDataIds = uploadingFiles.map(el => el.id)
          let keys = uploadingFiles.map(el => el.key)
          pauseImportService({ fileDataIds, keys }).then(response => {
            if (response.isSuccess) {
              sessionStorage.setItem('importPauseFlag', true)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          sessionStorage.setItem('importPauseFlag', true)
        }
      })
    },
    queryFilesUpload() {
      return new Promise(resolve => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          status: [1]
        }
        importUploadListService(params).then(response => {
          if (response.isSuccess) {
            let result = response.data
            let uploadingFiles = result.items
            uploadingFiles = uploadingFiles.filter(el => el.isMineUpload)
            resolve(uploadingFiles)
          }
        })
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.data-publish-container {
  height: 100%;
  background: var(--page-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  .common-tabs-box {
    position: relative;
    height: 100%;

    .tab-page-primary {
      // padding: 16px;
      padding-bottom: 0;
      height: 100%;

      :deep(.el-tabs__header) {
        padding: 5px 16px 0 16px;
      }

      :deep(.el-tabs__content) {
        height: calc(100% - 46px);

        .el-tab-pane {
          height: calc(100% - 16px);

          .export-data-box {
            .common-table-box {
              height: calc(100% - 64px);
            }
          }
        }
      }
    }

    .tabs-btn-box {
      position: absolute;
      display: flex;
      top: 10px;
      right: 20px;

      .items-box {
        margin-left: 15px;

        .icon {
          margin-right: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
